export default () => {
    const header = $("#header");

    if (header) {
        const pathname = window.location.pathname;
        const isEN = shoptet.cookie.get("language") === "en";

        $("#navigation").insertBefore(".navigation-buttons");
        $(".top-navigation-tools").insertBefore(".navigation-buttons");
        $(".languagesMenu").insertAfter(".search");

        $(".languagesMenu__list__link--currency:contains('CZK')").html("KČ");
        $(".languagesMenu__list__link--currency:contains('EUR')").html("€");
        $(".languagesMenu__header--actual:contains('CZK')").html("KČ");
        $(".languagesMenu__header--actual:contains('EUR')").html("€");

        $(".languagesMenu__list__name:contains('Čeština')").html("CZ");
        $(".languagesMenu__list__name:contains('English')").html("EN");
        $(".languagesMenu__header--actual:contains('Čeština')").html("CZ");
        $(".languagesMenu__header--actual:contains('English')").html("EN");

        if ($(".languagesMenu__flags .shp-flag-CZ").length > 0) {
            $(".languagesMenu__flags").html("CZ");
        }
        if ($(".languagesMenu__flags .shp-flag-GB").length > 0) {
            $(".languagesMenu__flags").html("EN");
        }
    }
};